
const ua = navigator.userAgent
const isAndroidApp = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;

import { Options, Vue } from "vue-class-component";
import { 
  getQuestion, 
  getVideoDetail, 
  getCorrect, 
  getReCommendQuestion, 
  addWrongQuestion, 
  cancelWrongQuestion, 
  checkWrongQuestionStatus,
  getSettingsList } from "@/api/index";
import mobileNativeSDK from '@/assets/js/mobileNativeSDK.js'
import QuestionDetail from "../components/QuestionDetail.vue"
import Rocket from "../components/Rocket.vue"
import CloseRecommend from "../components/CloseRecommend.vue"
import { getCurrentInstance } from "vue";
import { isNewBridgeView } from '@/assets/js/utils.js'
import { getClientCommonMessage, getData, showActiveAlert, nativeToast, playVideo, nativeConfirm } from '@/utils/nativeFn'
import { registerFnHandler } from '@/utils/registerFnHandler'
@Options({
  components: {
    QuestionDetail,
    Rocket,
    CloseRecommend
  },
})
export default class QuestionResult extends Vue {
  questions: any = []
  currentQuestionIndex: number = 0
  currentQuestion:any = {}
  isLoading: boolean = false
  imageUrl: string = ''
  loadingStatus: number = 0
  hasResolve: boolean = true
  recommendQuestions: any[] = []
  isShowRocket: boolean = false // 是否显示火箭图标
  scrollTop: number = 0
  questionResolves: any[] = [] // 所有题目的解析
  isAjaxing: boolean = false
  receiveQuestionIndex: any = null
  isIntellectRecommend: string = ''
  source: string = "compareAnswer"
  $xesLog = getCurrentInstance()?.appContext.config.globalProperties.$xesLog;
  serviceVersion: number = 0
  queryDone: boolean = false
  mounted() {
    if (isNewBridgeView()) {
      this.initNewData()
    } else {
      window['$eventBus'].addListener('receiveAndroidMsg', this.receiveAndroidMsg);
      window['$eventBus'].addListener('receiveIosMsg', this.receiveChangeQuestionMsg);
      window['$eventBus'].addListener('refreshQuestionStatus', this.refreshQuestionStatus);
      this.getNativeData()
    }
    window.addEventListener("scroll", this.showbtn, true);
    // this.getCorrectData()
  }
  // 新的dsbridge初始化
  initNewData() {
    // 监听题目切换
    registerFnHandler('changeQuestion', (res) => {
      console.log(res, 'new changeQuestion')
      // let respones = res[0]? res[0]: {}
      this.receiveChangeQuestionMsg(res)
    })
    // 监听刷新数据
    registerFnHandler('refreshQuestionStatus', (res) => {
      this.refreshQuestionStatus()
    })
    this.getNewNativeData()
    let num = 0
    let timer = setInterval(() => {
      if(this.queryDone) {
        clearInterval(timer)
        return
      } else {
        this.getNewNativeData()
        num++
        if (num === 10) {
          clearInterval(timer)
          this.initApiData()
        }
      }
    }, 500)
  }
  // 刷新所有题目收藏状态
  refreshQuestionStatus() {
    this.questionResolves.forEach((item, index) => {
      // console.log(item, 'item1')
      if (item && item.nryContent && item.nryContent.nry_question_id) {
        let params = {
          nry_question_id: item.nryContent.nry_question_id
        }
        checkWrongQuestionStatus(params).then(res => {
          if (res.data.code === 0) {
            item.nryContent.is_wrong_question = res.data.data.is_wrong_question
            // console.log(item, 'item2')
          }
        })
      }
      
    })
  }
  // 安卓监听消息
  receiveAndroidMsg(res) {
    let androidResult: any = JSON.parse(res)
    if (androidResult.event == 'getData') { // 监听获取数据返回
      this.detailNativeData(androidResult.dataJson)
    }
    if (androidResult.event === 'changeQuestion') { // 监听调用切换题目事件
      let tempIndex = androidResult.dataJson.questionIndex? Number(androidResult.dataJson.questionIndex) : 0
      this.receiveQuestionIndex = tempIndex
      this.changeQuestion(tempIndex)
    }
    if (androidResult.event === 'refreshQuestionStatus') {
      this.refreshQuestionStatus()
    }
  }
  //监听ios消息
  receiveChangeQuestionMsg(res) {
    this.receiveQuestionIndex = res.questionIndex? res.questionIndex: 0
    this.changeQuestion(res.questionIndex)
  }
  // 重新加载
  reload() {
    this.getNativeData()
  }
  // 视频未激活提示
  showActiveAlert(msg) {
    const data = {
      message_info: msg
    }
    if (isNewBridgeView()) {
      showActiveAlert(data, (res) => {
        console.log('视频未激活弹窗', res)
      })
      return
    }
    mobileNativeSDK.showActiveAlert(data, (res: any) => {
      console.log(res)
    })
  }

  //切换题目
  changeQuestion(index) {
    if (this.questions.length === 0) {
      return
    }
    if (this.currentQuestionIndex == index) {
      return
    }
    this.currentQuestionIndex = index
    this.currentQuestion = this.questions[this.currentQuestionIndex]
    this.getQuestionData(index)
  }
  // 根据二维码信息获取视频地址
  getVideoInfo() {
    if (this.isAjaxing) {
      return
    }
    const data = {
      nry_question_id: this.currentQuestion.nry_question_id,
      // scan_string: 'https://presscode.xueersi.com/index/scan?id=6570',
    };
    this.isAjaxing = true
    // 老版本获取视频数据直接播放
    getVideoDetail(data)
      .then((res) => {
        this.isAjaxing = false
        if (res.data.code == 0) {
          const params = {
            resource_vod_src: res.data.data.resource_vod_src,
            resource_src: res.data.data.resource_src,
            column_id: '0',
            min_column_id: '0',
            content_id: res.data.data.content_id,
            unionid: res.data.data.unionid,
            sn: res.data.data.sn || '',
            source_list: res.data.data.source_list || [],
            is_dot: res.data.data.is_dot,
            title: res.data.data.title
          }
          // 点击播放视频埋点
          this.$xesLog.track("oneself_check_page_exer_ana_play_video_click", {
            biz_name:'paipai',
            page_name:'自己对答案页',
            event_name:'自己对答案页-『题目解析』浮层-『播放视频』按钮点击（H5）',
            event_type: "click",
            nry_question_id:res.data.data.nry_question_id || '',
            content_id: res.data.data.content_id || ''
          });
          // 唤起native端的播放器
          if (isNewBridgeView()) {
            if (!res.data.data.resource_vod_src && !res.data.data.resource_src) {
              nativeToast('暂无可播放视频资源')
              return
            }
            playVideo(params, (res) => {
              console.log('调用视频播放', res)
            })
          } else {
            mobileNativeSDK.playVideo(params, (res: any) => {
              console.log(res);
            });
          }
        }else if (res.data.code == 100210) {
          this.showActiveAlert(res.data.message)
        } else {
          let msg = res.data.message? res.data.message: '获取视频地址失败'
          if (isNewBridgeView()) {
            nativeToast(msg)
            return
          }
          mobileNativeSDK.nativeToast({
            message: msg,
            timer: 2
          })
        }
      })
      .catch((err) => {
        this.isAjaxing = false
        console.log(err, "失败");
      });
  }
  // 新端获取数据
  getNewNativeData() {
    if (this.queryDone) {
        return
    }
    getClientCommonMessage({}, (res) => {
      console.log(res,'h5调用端上getClientCommonMessage')
      res.token && localStorage.setItem('tal_token', res.token)
      res.user_id && localStorage.setItem('TAL_UID_TMP', res.user_id)
      res.services_version = localStorage.setItem('service_version', res.service_version)
      this.serviceVersion = Number(res.service_version);
      this.queryDone = true
      getData((detailRes) => {
        // console.log('detailRes', detailRes)
        // let detailRes = respones[0]
        if (!detailRes || !detailRes.img_url) {
          this.loadingStatus = 2
          return
        }
        this.imageUrl = detailRes.img_url
        this.initApiData()
      })
    })
  }
  // 从端上获取数据
  getNativeData() {
    mobileNativeSDK.getData((res) => {
      if (!isAndroidApp) {
        console.log(res, '11111')
        this.detailNativeData(res)
      }
    })
  }
  // 处理端上数据
  detailNativeData(res) {
    if (!res || !res.img_url) {
      this.loadingStatus = 2
      return
    }
    if (localStorage.getItem('tal_token') !== res.token) {
      localStorage.setItem('tal_token', res.token)
    }
    if (res.service_version) {
      this.serviceVersion = Number(res.service_version);
      localStorage.setItem('service_version', res.service_version)
    }
    this.imageUrl = res.img_url
    this.initApiData()
  }
  // 初始化接口数据
  async initApiData() {
    if (this.serviceVersion > 13) {
      await this.getSettingsList()
    } else {
      this.isIntellectRecommend = '1'
    }
    this.getCorrectData()
  }
  // 获取用户设置
  getSettingsList() {
    return getSettingsList().then((res) => {
      if (res.data.code != 0) {
        return
      }
      this.isIntellectRecommend = res.data.data.is_intellect_recommend
    }).catch((err) => {
      console.log(err)
    })
  }
  // 获取题目解析
  getQuestionData(index) {
    // 如果解析数组中已存在该题目解析，不去请求接口
    if (this.questionResolves[index].hasResolve === 2) {
      this.renderResolve(this.questionResolves[index].nryContent);
      return
    }
    const data = {
      nry_question_id: this.currentQuestion.nry_question_id,
    };
    if (!this.isLoading) {
      this.isLoading = true
    }
    getQuestion(data)
      .then((res) => {
        this.isLoading = false
        if (res.data.code != 0) {
          this.questionResolves[index].hasResolve = 1
          if (isNewBridgeView()) {
            let errMeg = res.data.message ? res.data.message : "获取题目解析失败";
            nativeToast(errMeg)
            return
          }
          mobileNativeSDK.nativeToast({
            message: res.data.message? res.data.message: '获取题目解析失败',
            timer: 2
          })
          return
        }
        if (JSON.stringify(res.data.data) == "{}" || !res.data.data.question_detail || JSON.stringify(res.data.data.question_detail) == "{}") {
          this.questionResolves[index].hasResolve = 1
          return
        }
        let nryContent = res.data.data;
        this.questionResolves[index].hasResolve = 2
        this.questionResolves[index].nryContent = nryContent; //将获取到的解析存储到数组中
        this.renderResolve(nryContent);
        // 获取对应的推荐题目
        if (this.isIntellectRecommend == '1' && !this.recommendQuestions[index]) {
          this.getRecommendQuestions(nryContent.nry_question_id, index)
        }
      })
      .catch((err) => {
        console.log(err, 'questionError')
        this.isLoading = false
        this.questionResolves[index].hasResolve = 1
      });
  }
  // 渲染解析
  renderResolve(nryContent) {
    this.$nextTick(() => {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      let questionTitleDom: any = document.getElementById('question_title');
      let questionAnalysisDom: any = document.getElementById('question_analysis');
      try {
        // questionTitleDom.innerHTML = (window as any).TalqsTemplate.renderPartialComponent('question', nryContent.question_detail, {
        //   hideDifficulty: true,
        //   hideSource: true,
        //   hideCamera: true,
        // });
        questionTitleDom.innerHTML = (window as any).TalqsTemplate.render(nryContent.question_detail, {
          hideDifficulty: true,
          hideSource: true,
          hideCamera: true,
        });
        questionAnalysisDom.innerHTML = (window as any).TalqsTemplate.renderPartialComponent('questionAnalyze', nryContent.question_detail, {
          hideDifficulty: true,
          hideSource: true,
          hideCamera: true,
        });

        (window as any).MathJax.Hub.Queue(['Typeset', (window as any).MathJax.Hub, questionTitleDom]);
        (window as any).MathJax.Hub.Queue(['Typeset', (window as any).MathJax.Hub, questionAnalysisDom]);

        this.$nextTick(() => {
          (window as any).TalqsTemplate.autoLayout();
        });
      } catch (e) {
        console.log('error', e);
      }
    })
    
  }
  // 获取题目信息
  getCorrectData() {
    const data = {
      // image_url: "https://xesbook-inside.oss-cn-beijing.aliyuncs.com/source/uploads/app/photo/20220510/_uf226c5fad0e15ef_1652184101.jpeg",
      image_url: this.imageUrl
    };
    this.isLoading = true
    getCorrect(data)
      .then((res: any) => {
        // console.log('res',res.data.code, res.data.data)
        if (res.data.code != 0) {
          this.isLoading = false
          this.loadingStatus = 2
          return
        }
        this.loadingStatus = 1
        let ansImgQuestions = res.data.data.correct_data.ans_img_questions || []
        ansImgQuestions.forEach((item) => {
          if (item.nry_question_id) {
            // 将有nry_question_id的元素提取出来
            this.questions.push(item)
            // 初始化有内容云id的题目的解析
            let tempObj = {
              hasResolve: 0,
              nryContent: null
            }
            this.questionResolves.push(tempObj)
          }
        })
        if (this.receiveQuestionIndex) {
          this.currentQuestionIndex = this.receiveQuestionIndex
        }
        this.currentQuestion = this.questions[this.currentQuestionIndex]
        this.getQuestionData(this.currentQuestionIndex)
      })
      .catch((err: any) => {
        this.loadingStatus = 2
        this.isLoading = false
        console.log(err, "失败");
      });
  }
  // 获取智能推荐题目
  getRecommendQuestions(nry_question_id, index) {
    if (!nry_question_id) {
      return
    }
    const data = {
      question_id: nry_question_id,
    };
    getReCommendQuestion(data).then((res) => {
      if (res.data.code === 0 && res.data.data.list) {
        this.recommendQuestions[index] = res.data.data.list
      }
    })
  }
  // 返回顶部
  goTop() {
    var timer = setInterval(function () {
      let osTop = document.documentElement.scrollTop || document.body.scrollTop;
      let ispeed = Math.floor(-osTop / 5);
      document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
      this.isTop = true;
      if (osTop === 0) {
        clearInterval(timer);
      }
    }, 30);
  }
  // 监听scroll事件
  showbtn() {
    let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
    this.scrollTop = scrollTop;
    let windowHeight = document.documentElement.clientHeight
    if (scrollTop > windowHeight) {
      this.isShowRocket = true;
    } else {
      this.isShowRocket = false;
    }
  }
  // 显示智能推荐说明
  showRecommendTips() {
    this.$xesLog.track("oneself_check_page_exer_ana_int_rec_help_click", {
      biz_name:'paipai',
      page_name:'自己对答案',
      event_name:'自己对答案页-『题目解析』浮层-『i』按钮点击（H5）',
      event_type: "click"
    });
    if (isNewBridgeView()) {
      nativeConfirm({
        message:
          "1.智能推荐：根据拍批题目的知识点，进行智能化相似题推荐，举一反三，从而让孩子针对性的巩固练习；\n\n2.推荐3道题的原因：根据学而思十几年教研经验总结得出，3道题比较利于孩子在合适的时间长度，掌握知识点，又不会觉得题目太多产生厌学。",
        confirmButtonText: "我知道了",
      }, (res) => {
        console.log('native confirm', res)
      })
      return
    }
    mobileNativeSDK.nativeConfirm({
      message: '1.智能推荐：根据拍批题目的知识点，进行智能化相似题推荐，举一反三，从而让孩子针对性的巩固练习；\n\n2.推荐3道题的原因：根据学而思十几年教研经验总结得出，3道题比较利于孩子在合适的时间长度，掌握知识点，又不会觉得题目太多产生厌学。',
      buttonTxt: '我知道了'
    })
  }
  // 加入错题本
  addWrongList(nry_question_id) {
    if (this.isAjaxing) {
      return
    }
    let params = {
      nry_question_id
    }
    this.isAjaxing = true
    addWrongQuestion(params).then((res) => {
      this.isAjaxing = false
      if (res.data.code !== 0 && res.data.code !== 100901) {
        if (isNewBridgeView()) {
          nativeToast(res.data.message)
          return
        }
        mobileNativeSDK.nativeToast({
          message: res.data.message,
          timer: 2
        })
        return
      }
      this.questionResolves[this.currentQuestionIndex].nryContent.is_wrong_question = 1
      let hasAddWrongQuestion = localStorage.getItem('hasAddWrongQuestion')
      if (!hasAddWrongQuestion) {
        localStorage.setItem('hasAddWrongQuestion', '1')
        if (isNewBridgeView()) {
          nativeConfirm({
            message:
              "加入错题本的题目可以在「我的」-「错题本」中进行查看题目和解析哦。",
            confirmButtonText: "我知道了",
          }, (res) => {
            console.log('native confirm', res)
          })
          return
        }
        window['$mobileNativeSDK'].nativeConfirm({
          message: '加入错题本的题目可以在「我的」-「错题本」中进行查看题目和解析哦。',
          buttonTxt: '我知道了'
        })
        return
      }
      if (isNewBridgeView()) {
        nativeToast('加入成功')
        return
      }
      mobileNativeSDK.nativeToast({
        message: '加入成功',
        timer: 2
      })
      // 点击加入错题本
      this.$xesLog.track("oneself_check_page_exer_ana_add_false_notebook_click", {
        biz_name:'paipai',
        page_name:'自己对答案页',
        event_name:'自己对答案页-『题目解析』浮层-『加入错题本』按钮点击（H5）',
        event_type: "click",
        nry_question_id:params.nry_question_id || '',
        exer_status:'add_into_notebook'
      });
    }).catch((err) => {
      this.isAjaxing = false
      console.log(err)
    })
  }
  // 移出错题本
  cancelWrongQuestion(nry_question_id) {
    if (this.isAjaxing) {
      return
    }
    let params = {
      nry_question_id
    }
    this.isAjaxing = true
    cancelWrongQuestion(params).then((res) => {
      // 点击加入错题本
      this.$xesLog.track("oneself_check_page_exer_ana_add_false_notebook_click", {
        biz_name:'paipai',
        page_name:'自己对答案页',
        event_name:'自己对答案页-『题目解析』浮层-『加入错题本』按钮点击（H5）',
        event_type: "click",
        nry_question_id:params.nry_question_id || '',
        exer_status:'remove_notebook'
      });
      this.isAjaxing = false
      if (res.data.code !== 0  && res.data.code !== 100902) {
        if (isNewBridgeView()) {
          nativeToast(res.data.message)
          return
        }
        mobileNativeSDK.nativeToast({
          message: res.data.message,
          timer: 2
        })
        return
      }
      this.questionResolves[this.currentQuestionIndex].nryContent.is_wrong_question = 0
      if (isNewBridgeView()) {
        nativeToast('移出成功')
        return
      }
      mobileNativeSDK.nativeToast({
        message: '移出成功',
        timer: 2
      })
    }).catch((err) => {
      this.isAjaxing = false
      console.log(err)
    })
  }
}
